var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.baseClass},_vm._l((_vm.scoreCriteriaDetailTypes),function(criteriaDetailType){return _c('EpbBadge',{key:criteriaDetailType,class:[
      `${_vm.baseClass}__badge`,
      `${_vm.baseClass}__badge--${criteriaDetailType} ${_vm.baseClass}__badge--new-version`,
    ],style:({
      width: _vm.getCriteriaBarWidth(criteriaDetailType),
    }),attrs:{"size":"extra-mini","tooltip":_vm.getScoreCriteriaDetailLabel(criteriaDetailType)}},[_c('span',{class:[
        `${_vm.baseClass}__icon eicon`,
        `${_vm.baseClass}__icon--${_vm.getResultScoreCriteriaDetailColor(criteriaDetailType)}`,
      ]},[_vm._v("\n      "+_vm._s(_vm.getResultScoreCriteriaDetailIcon(criteriaDetailType))+"\n    ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }